import React from 'react';

const COUNTRY_FLAGS = { IT: '🇮🇹', ES: '🇪🇸' };

const CountrySelector = ({ country, onCountryChange, countries }) => {
  return (
    <div className="country-toggle" role="radiogroup" aria-label="Seleziona paese">
      {countries.map((c) => (
        <button
          key={c}
          className={`country-toggle-btn${c === country ? ' active' : ''}`}
          onClick={() => onCountryChange(c)}
          role="radio"
          aria-checked={c === country}
          aria-label={c}
        >
          <span className="country-flag">{COUNTRY_FLAGS[c] || c}</span>
          <span className="country-code">{c}</span>
        </button>
      ))}
    </div>
  );
};

export default CountrySelector;
